import { useState } from 'react'
import {
  AppLayout,
  Mtds,
  PlusIcon,
  ScreenHeader,
  ScreenLayout,
  TopBar,
  useGetSubPurposesQuery
} from 'prove-common'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'
import { SubPurposesTable } from '../tables/sub-purposes-table/SubPurposesTable'
import { SubPurposeForm } from '../components/reference-data/ReferenceEntityForms'
import { ReferenceQueryStatus } from '../components/reference-data/ReferenceQueryStatus'

export const SubPurposesScreen = () => {
  const [isModalOpen, setModalOpen] = useState(false)
  const {
    data: subPurposes,
    isFetching,
    isError,
    refetch
  } = useGetSubPurposesQuery()
  return (
    <AppLayout
      useMobileBar={false}
      isFullWidth
      sidebar={<SideBarLayout />}
      topBar={<TopBar logo={<AppLogo />} title='Underhensikter' />}
    >
      <ScreenLayout
        header={
          <ScreenHeader
            title='Underhensikter'
            description='Underhensikter gir en mer detaljert beskrivelse av hensikten med prøvetakingen.'
            actions={
              <Mtds.Button
                data-variant='primary'
                onClick={() => setModalOpen(true)}
              >
                <PlusIcon />
                Legg til underhensikt
              </Mtds.Button>
            }
          />
        }
      >
        <ReferenceQueryStatus
          hasData={subPurposes != null}
          isFetching={isFetching}
          isError={isError}
          refetch={refetch}
        />
        {subPurposes ? <SubPurposesTable subPurposes={subPurposes} /> : null}
      </ScreenLayout>
      {isModalOpen && <SubPurposeForm onClose={() => setModalOpen(false)} />}
    </AppLayout>
  )
}
